import script from "./OpportunitiesChart.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunitiesChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__